import { CloseCircle } from 'entities/close-circle/model'

import { BlockSelect } from 'shared/ui/select/components/select-block'

interface CloseCircleDialogProps {
  closeCircles: CloseCircle[]
  onSelect: (closeCircle: CloseCircle) => void
}

export const CloseCircleDialog = ({
  closeCircles,
  onSelect,
}: CloseCircleDialogProps) => (
  <div>
    <BlockSelect
      listOption={closeCircles.map((closeCircle) => ({
        value: String(closeCircle.id),
        name:
          closeCircle.label ||
          [closeCircle.last_name, closeCircle.first_name]
            .filter(Boolean)
            .join(' '),
      }))}
      onChange={({ value }) => {
        const closeCircle = closeCircles.find((item) => item.id === value)

        if (closeCircle) {
          onSelect(closeCircle)
        }
      }}
    />
  </div>
)
